import type { IDrillDownFilterCategory } from './DrillDownFilter.types'

const labelMatchesTerm = (label: string, term: string): boolean => {
  const normalized = term.trim().toLowerCase()
  if (!normalized) return true
  return label.toLowerCase().includes(normalized)
}

export const filterDrillDownCategoryItems = <T>(
  category: IDrillDownFilterCategory<T>,
  term: string,
): T[] => {
  return category.items.filter(item =>
    labelMatchesTerm(category.getItemLabel(item), term),
  )
}

export const filterDrillDownCategories = <T>(
  categories: IDrillDownFilterCategory<T>[],
  term: string,
): IDrillDownFilterCategory<T>[] => {
  return categories.filter(category => labelMatchesTerm(category.label, term))
}
